import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface DetailListItem {
  label: string;
  value: ReactNode;
  description?: ReactNode;
  fullWidth?: boolean;
}

/** Quiet labels, readable values and supporting prose; emphasis is deliberate. */
export function DetailList({ items, className, ...props }: HTMLAttributes<HTMLDListElement> & { items: DetailListItem[] }) {
  return <dl className={cn("ui-detail-list", className)} {...props}>
    {items.map(({ label, value, description, fullWidth }) => <div key={label} data-full-width={fullWidth || undefined}>
      <dt>{label}</dt>
      <dd><div className="ui-detail-list-value">{value}</div>{description && <p className="ui-detail-list-description">{description}</p>}</dd>
    </div>)}
  </dl>;
}
